export default "__VITE_ASSET__Bo4q4zYH__"